import React from 'react'
import styles from './Exports.css'
import ExportIcon from 'static/images/export-download.svg'

class Exports extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      match,
      setExportId,
      getExports,
      resetState,
    } = this.props

    resetState()
    setExportId(match)
    getExports()
  }

  componentDidUpdate() {
    if (this.downloadRef) {
      this.downloadRef.click()
    }
  }

  downloadRef = React.createRef()

  render() {
    const {
      url,
    } = this.props
    return (
      <div data-page="exports" className={styles.exports}>
        {url &&
          <div>
            <ExportIcon />
            <h1>Your export is being downloaded.</h1>
            <div className={styles.exportActions}>
              <div className={styles.tryAgainExport}>
                If your download has not begun click below to try again.
                <div className={styles.tryAgainLink}>
                  <a
                    ref={node => { this.downloadRef = node }}
                    href={url}
                  >
                    Download
                  </a>
                </div>
              </div>
              You can close this window.
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Exports



// WEBPACK FOOTER //
// ./src/legacy/pages/Exports/Exports.jsx